import React, { Component } from "react";
import { NormalButton, NormalInput } from "component/common";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { history } from "helpers";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import { Toast } from "service/toast";
import printJS from "print-js";
import { transactionSettingListAct } from "redux/actions/transactionHistory";
import AddIcon from "../../../assets/images/add.png";
import deleteIcon from "../../../assets/images/delete1.png";

export class EditInsuranceClass extends Component {
  state = {
    editableData: {},
    editTableDescription: [],
    paymentType: [],
    getTotalData: {},
    responseData: [],
    subData: {},
  };

  componentDidMount() {
    this.getInvoiceSettingList();
    this.setState({ editTableDescription: [{}] });
  }

  // getInvoiceSettingList
  getInvoiceSettingList = () => {
    let { editableData } = this.state;
    this.props
      .getCommonApi(
        `insuranceinvoiceget/?sa_transacno=${this.props.match.params.id}`
      )
      .then(async (res) => {
        const {
          tot_qty,
          tot_net,
          tot_paid,
          tot_price,
          tot_bal,
          outstanding,
          sub_total,
          tot_disc,
          prepaid_balance,
          creditnote_balance,
          total_netprice,
        } = res.sub_data;
        const { gst_label, gst, total, rounding, grand_tot } = res.taud_sub;
        // let responseData = res.data.data;
        // console.log(responseData, "responseData");

        // const { customer_name, date, daud_lines, transaction_no } =
        //   responseData;

        // Extract relevant data and update the state
        // const editableData = {
        //   customerName: customer_name,
        //   date: this.extractDateFromDateStr(date),
        //   time: this.extractTimeFromDateStr(date),
        //   transactionNo: transaction_no,
        // };
        const editTableDescription = res.dtl_data.map((line) => ({ ...line }));
        const paymentType = res.taud_data.map((list) => ({ ...list }));
        const getTotalData = {
          gst_label,
          gst,
          total,
          rounding,
          grand_tot,
          outstanding,
          sub_total,
        };
        console.log(getTotalData, "editHeader");
        this.setState({
          editableData: res.hdr_data,
          editTableDescription,
          paymentType,
          getTotalData,
          subData: res.sub_data,
        });
      });
  };
  extractDateFromDateStr = (dateStr) => {
    const dateTime = new Date(dateStr);
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return dateTime.toLocaleDateString(undefined, options);
  };

  // Function to extract time from the given date string
  extractTimeFromDateStr = (dateStr) => {
    const dateTime = new Date(dateStr);
    const options = { hour: "2-digit", minute: "2-digit" };
    return dateTime.toLocaleTimeString(undefined, options);
  };

  // handleCheckStatus
  handleChangeCheckStatus = (arrayData, name) => {
    if (arrayData) {
      const status = arrayData.some(
        (obj) =>
          obj.hasOwnProperty("name") &&
          obj.name === name &&
          obj.checked === true
      );
      return status;
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      editableData: {
        ...prevState.editableData,
        [name]: value,
      },
    }));
    console.log();
  };
  handleTotalChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      getTotalData: {
        ...prevState.getTotalData,
        [name]: value,
      },
    }));
  };
  handleLineInputChange = (e, index) => {
    let { editTableDescription } = this.state;
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedLines = [...prevState.editTableDescription];
      updatedLines[index][name] = value;
      return { editTableDescription: updatedLines };
    });
    console.log(editTableDescription, "editTable");
  };
  handlePaymentChange = (e, index) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const updatedLines = [...prevState.paymentType];
      updatedLines[index][name] = value;
      return { paymentType: updatedLines };
    });
  };
  handleAddLine = () => {
    const newLine = {
      dt_itemdesc: "",
      dt_qty: "",
      dt_price: "",
      discount: "",
      dt_transacamt: "",
      dt_deposit: "",
      sales_staff: "",
      work_staff: "",
    };
    this.setState((prevState) => ({
      editTableDescription: [...prevState.editTableDescription, newLine],
    }));
  };
  handleDeleteLine = (index) => {
    if (this.state.editTableDescription.length === 1 && index === 0) {
      this.setState({
        editTableDescription: [
          {
            dt_itemdesc: "",
            dt_qty: "",
            dt_price: "",
            discount: "",
            dt_transacamt: "",
            dt_deposit: "",
            sales_staff: "",
            work_staff: "",
          },
        ],
      });
    } else {
      this.setState((prevState) => {
        const updatedLines = [...prevState.editTableDescription];
        updatedLines.splice(index, 1);
        return { editTableDescription: updatedLines };
      });
    }
  };
  handleAddPaymentLine = () => {
    let newLine = {
      pay_type_name: "",
      pay_amt: "",
    };
    this.setState((prevState) => ({
      paymentType: [...prevState.paymentType, newLine],
    }));
  };
  handleDeletePaymentLine = (index) => {
    let { paymentType } = this.state;
    console.log(paymentType.length, "payType");
    console.log(index, "index");
    if (paymentType.length === 1 && index === 0) {
      this.setState({
        paymentType: [
          {
            pay_type_name: "",
            pay_amt: "",
          },
        ],
      });
    } else {
      this.setState((prevState) => {
        const updatedLines = [...prevState.paymentType];
        updatedLines.splice(index, 1);
        return { paymentType: updatedLines };
      });
    }
  };
  handleCreate = () => {
    const { editTableDescription, editableData, paymentType, getTotalData } =
      this.state;
    const {
      gst_label,
      gst,
      total,
      rounding,
      grand_tot,
      outstanding,
      sub_total,
    } = getTotalData;
    let daudId = editTableDescription[0].id;
    let recordDetail = editTableDescription[0].record_detail_type;

    console.log(editTableDescription, "editTableDescription");
    console.log(getTotalData, " getTotalData,");
    console.log(editableData, "editableData");
    console.log(paymentType, "paymentType");

    if (Object.values(editTableDescription[0]).every((value) => value === "")) {
      Toast({
        type: "error",
        message: "Please add invoice details",
      });
    } else if (Object.values(paymentType[0]).every((value) => value === "")) {
      Toast({
        type: "error",
        message: "Please add a Payment type",
      });
    } else {
      const maxLength = Math.max(
        editTableDescription.length,
        paymentType.length
      );
      const inputDate = editableData.sa_date;
      const inputTime = editableData.sa_time;
      const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };
      const dateParts = inputDate.split("-");
      const formattedDate = `${dateParts[2]}-${
        monthMap[dateParts[1]]
      }-${dateParts[0].padStart(2, "0")}`;
      const parsedTime = new Date(`2000-01-01 ${inputTime}`);
      const formattedTime = `${parsedTime
        .getHours()
        .toString()
        .padStart(2, "0")}:${parsedTime
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${parsedTime
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;
      const formattedDateTime = `${formattedDate} ${formattedTime}`;
      const transactionLines = Array.from({ length: maxLength }, (_, index) => {
        const item = editTableDescription[index] || editTableDescription[0];
        const paymentInfo = paymentType[index] || paymentType[0];

        const staffArray = item.work_staff.split(",");
        const salesStaff = item.sales_staff || "";
        let formattedString;

        if (staffArray.length > 1) {
          formattedString = `${salesStaff}/${staffArray.join(",")}`;
        } else {
          formattedString = `${salesStaff}/${staffArray[0]}`;
        }
        return {
          sa_transacno: this.props.match.params.id,
          sa_date: formattedDateTime,
          sa_time: formattedDateTime,
          cust_phone2: editableData.cust_phone2,
          cust_nric: editableData.nric,
          cas_name: editableData.sa_custname,
          sa_totamt: parseFloat(total),
          sa_totQty: parseInt(item.dt_qty, 10) || 0,
          sa_totdisc: parseFloat(total),
          sa_totgst: parseFloat(gst),
          issued_by: editableData.issued,
          sa_custno: editableData.sa_custno,
          sa_custname: editableData.sa_custname,
          IsVoid: "",
          Void_RefNo: "",
          Payment_Remarks: null,
          sa_TransacAmt: null,
          Trans_Remark: null,
          SA_TransacNo_Title: null,
          tot_price: parseFloat(item.dt_transacamt) || 0,
          tot_qty: parseInt(item.dt_qty, 10) || 0,
          pay_gst: parseFloat(gst),
          sa_remark: null,
          rounding: parseFloat(rounding),
          outstanding: parseFloat(outstanding),
          trans: editableData.trans,
          dt_price: parseFloat(item.dt_price) || 0,
          dt_status: item.dt_status || "",
          dt_itemdesc: item.dt_itemdesc || "",
          sa_staffname: item.sales_staff || "",
          service_by: formattedString || "",
          dt_qty: parseInt(item.dt_qty, 10) || 0,
          discount: parseFloat(item.discount) || 0,
          no: index + 1,
          isfoc: false,
          record_detail_type: recordDetail,
          pay_type_name: paymentInfo.pay_type_name || "",
          pay_rem1: null,
          pay_amt: parseFloat(paymentInfo.pay_amt || 0),
        };
      });

      this.props
        .commonCreateApi(`insuranceinvoice/`, transactionLines)
        .then((res) => {
          console.log(res, "Res");
          history.push({
            pathname: "/admin/downloadinsurance",
            state: this.props.match.params.id,
          });
        });
    }
  };

  render() {
    let {
      responseData = {},
      downloadlLink,
      editableData,
      editTableDescription,
      isBackendPrintEnable,
      paymentType,
      getTotalData,
      subData,
    } = this.state;

    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;

    return (
      <>
        <div className="print-section container">
          <div className="print-bill">
            <div className="receipt " id="printableArea">
              <div className="bill-header" style={{ fontSize: "1rem" }}>
                <div className="row ">
                  <div className="col-6">
                    <div className="row ml-3">
                      <div className="col-3 f-600">Code</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="sa_custno"
                          value={editableData.sa_custno || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Name</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="sa_custname"
                          value={editableData.sa_custname || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">NRIC</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="nric"
                          value={editableData.nric || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Cust Refer</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="cust_refer"
                          value={editableData.cust_refer || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Cust Phone</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="cust_phone2"
                          value={editableData.cust_phone2 || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="row ml-3">
                      <div className="col-3  f-600">Trans</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="trans"
                          value={editableData.trans || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Date</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="sa_date"
                          value={editableData.sa_date || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Time</div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="sa_time"
                          value={editableData.sa_time || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 ml-3">
                      <div className="col-3  f-600">Issued </div>
                      <div className="col-7 d-flex">
                        <span className="mr-3">:</span>
                        <NormalInput
                          name="issued"
                          value={editableData.issued || ""}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="bill-detail mt-4 py-1"
                id="billDetailsHide"
                style={{ fontSize: ".915rem" }}
              >
                <div className="row m-0 table-header  f-600">
                  <div className="col text-left">No.</div>
                  <div className="col-3 text-left">Description</div>
                  <div className="col text-left">Qty</div>
                  <div className="col text-left">U/P</div>
                  <div className="col text-left">Disc.</div>
                  <div className="col text-left">N/P</div>
                  <div className="col text-left">Paid</div>
                  <div className="col text-left">Sold By</div>
                  <div className="col text-left">Service By</div>
                  <div className="col text-left">Actions</div>
                </div>
                <div id="firstloopdataHide">
                  {editTableDescription.length > 0
                    ? editTableDescription.map((item, index) => {
                        return (
                          <div className="row m-0 mt-2" key={index}>
                            <div className="col text-left">{index + 1}</div>

                            <div className="col-3 text-left">
                              <NormalInput
                                name="dt_itemdesc"
                                value={item.dt_itemdesc || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              {" "}
                              <NormalInput
                                name="dt_qty"
                                value={item.dt_qty || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="dt_price"
                                value={item.dt_price || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="discount"
                                value={item.discount || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="dt_transacamt"
                                value={item.dt_transacamt || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="dt_deposit"
                                value={item.dt_deposit || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="sales_staff"
                                value={item.sales_staff || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>

                            <div className="col text-left">
                              <NormalInput
                                name="work_staff"
                                value={item.work_staff || ""}
                                onChange={(e) =>
                                  this.handleLineInputChange(e, index)
                                }
                              />
                            </div>
                            <div className="col text-left">
                              <img
                                src={AddIcon}
                                alt="add"
                                className="add-icon mr-3"
                                onClick={this.handleAddLine}
                              />
                              <img
                                src={deleteIcon}
                                alt="add"
                                className="add-icon"
                                onClick={() => this.handleDeleteLine(index)}
                              />
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>

                <div className="row table-header sub-total m-0 fs-14 f-600 mt-5">
                  {/* <div className="col text-left"></div>
                  <div className="col-3 text-left"></div>
                  <div className="col text-center">{subData.tot_qty}</div>

                  <div className="col text-center">{subData.tot_price}</div>
                  <div className="col text-center">{subData.tot_disc}</div>
                  <div className="col text-center">{subData.tot_net}</div>

                  <div className="col text-center">{subData.tot_paid}</div>
                  <div className="col text-left"></div>
                  <div className="col text-left"></div>
                  <div className="col text-left"></div> */}
                </div>
              </div>
              <div className="payment-detail my-4  fw-600 mb-4">
                <div className="row m-0">
                  <div className="col-7">
                    <div className="row payment-header">
                      <div className="col-2">No</div>
                      <div className="col-4">Type</div>
                      <div className="col-3 ">Amount</div>
                      <div className="col-3 ">Actions</div>
                    </div>
                    {paymentType.length > 0
                      ? paymentType.map((item, index) => {
                          return (
                            <div className="row payment-header" key={index}>
                              <div className="col-2 my-2 d-flex align-items-center justify-content-center">
                                {index + 1}
                              </div>
                              <div className="col-4 my-2">
                                {" "}
                                <NormalInput
                                  name="pay_type_name"
                                  value={item.pay_type_name || ""}
                                  onChange={(e) =>
                                    this.handlePaymentChange(e, index)
                                  }
                                />
                              </div>
                              <div className="col-3 text-right my-2">
                                <NormalInput
                                  name="pay_amt"
                                  value={item.pay_amt || ""}
                                  onChange={(e) =>
                                    this.handlePaymentChange(e, index)
                                  }
                                />
                              </div>
                              <div className="col-3 my-2">
                                <img
                                  src={AddIcon}
                                  alt="add"
                                  className="add-icon mr-3"
                                  onClick={this.handleAddPaymentLine}
                                />
                                <img
                                  src={deleteIcon}
                                  alt="add"
                                  className="add-icon"
                                  onClick={() =>
                                    this.handleDeletePaymentLine(index)
                                  }
                                />
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </div>
                  <div className="col-5 text-right">
                    <div className="row">
                      <div className="col-6">Sub Total :</div>
                      <div className="col-6 text-right">
                        <NormalInput
                          name="sub_total"
                          value={getTotalData.sub_total || ""}
                          onChange={this.handleTotalChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">GST :</div>
                      <div className="col-6 text-right">
                        <NormalInput
                          name="gst"
                          value={getTotalData.gst || ""}
                          onChange={this.handleTotalChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">Rounding :</div>
                      <div className="col-6 text-right">
                        <NormalInput
                          name="rounding"
                          value={getTotalData.rounding || ""}
                          onChange={this.handleTotalChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">Grand Total :</div>
                      <div className="col-6 text-right">
                        <NormalInput
                          name="grand_tot"
                          value={getTotalData.grand_tot || ""}
                          onChange={this.handleTotalChange}
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">Outstanding :</div>
                      <div className="col-6 text-right">
                        <NormalInput
                          name="outstanding"
                          value={getTotalData.outstanding || ""}
                          onChange={this.handleTotalChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-5 d-flex justify-content-end text-center action-buttons">
              <div className="col-md-2 col-12 " id="hide-print-btn">
                <NormalButton
                  //mainbg={true}
                  className="confirm"
                  label="Cancel"
                  // outline={false}
                  onClick={async () => {
                    if (isBackendPrintEnable) {
                      printJS(downloadlLink);
                    } else {
                      await this.setState({
                        isPrintPdfPreview: true,
                      });
                    }
                  }}
                />
              </div>

              <div className="col-md-2 col-12 ">
                <NormalButton
                  //mainbg={true}
                  className="print colorTheme4"
                  label="Create"
                  onClick={this.handleCreate}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  appointmentDetail: state.appointment.appointmentDetail,
  tokenDetails: state.authStore.tokenDetails,
  transactionSettingList: state.transactionStore.transactionSettingList,
  transactionOrderChangeList: state.transactionStore.transactionOrderChangeList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      transactionSettingListAct,
    },
    dispatch
  );
};

export const EditInsurance = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInsuranceClass);